export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DowngradePlanDialog.json?hash=5d41a929c476afd426c832784bf4ffa9";